export const formattedName = (key: string) => {
    if (!key) return key;

    const [name, id] = key.split('::');
    return `${name} [${id}]`;
}